import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import React, { forwardRef, useLayoutEffect, useMemo, useRef, useState, } from 'react';
import MuiTooltip from '@material-ui/core/Tooltip';
import { combineClasses, combineProps, logInDev, styled, useDeprecatedCheck, useForkRef, useRcPortalWindowContext, useThemeProps, } from '../../foundation';
import { Mask, tooltipStyle } from './styles';
import { RcTooltipClasses, useTooltipForceHide } from './utils';
var _RcTooltip = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTooltip' });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcTooltip, props, [
            {
                prop: 'injectGlobalStyle',
                time: '2021-3',
                comment: "@deprecated now need anymore */",
            },
        ]);
    }
    var children = props.children, tooltipForceHide = props.tooltipForceHide, openProp = props.open, onOpen = props.onOpen, onClose = props.onClose, 
    // * that className will pass into children, just pick that and pass into root popper
    // * that also not a props in mui doc  https://material-ui.com/api/tooltip/
    classNameProp = props.className, classesProp = props.classes, PopperPropsProp = props.PopperProps, textColor = props.textColor, color = props.color, ignorePointer = props.ignorePointer, size = props.size, maskProps = props.maskProps, title = props.title, injectGlobalStyle = props.injectGlobalStyle, rest = __rest(props, ["children", "tooltipForceHide", "open", "onOpen", "onClose", "className", "classes", "PopperProps", "textColor", "color", "ignorePointer", "size", "maskProps", "title", "injectGlobalStyle"]);
    var externalWindow = useRcPortalWindowContext().externalWindow;
    var _a = __read(useState(false), 2), isDisabledButton = _a[0], setIsDisabledButton = _a[1];
    var innerRef = useRef(null);
    var tooltipRef = useForkRef(ref, innerRef);
    var classes = useMemo(function () {
        return combineClasses(combineClasses({ popper: classNameProp }, RcTooltipClasses), classesProp);
    }, [classNameProp, classesProp]);
    var PopperProps = useMemo(function () {
        return combineProps({
            container: externalWindow === null || externalWindow === void 0 ? void 0 : externalWindow.document.body,
        }, PopperPropsProp);
    }, [PopperPropsProp, externalWindow === null || externalWindow === void 0 ? void 0 : externalWindow.document.body]);
    var forceHideAdditionProps = useTooltipForceHide({
        ref: innerRef,
        tooltipForceHide: tooltipForceHide,
        open: openProp,
        onClose: onClose,
        onOpen: onOpen,
    });
    var additionProp = forceHideAdditionProps !== null && forceHideAdditionProps !== void 0 ? forceHideAdditionProps : {
        open: openProp,
        onOpen: onOpen,
        onClose: onClose,
    };
    // * use to fix when children button is `disabled` that error in Mui
    // * https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/Tooltip/Tooltip.js#L269
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useLayoutEffect(function () {
        var childNode = innerRef.current;
        if (isDisabledButton &&
            childNode &&
            childNode.tagName.toLowerCase() === 'button' &&
            childNode.disabled) {
            setIsDisabledButton(true);
            if (process.env.NODE_ENV !== 'production') {
                logInDev({
                    component: 'RcTooltip',
                    message: 'You have set a tooltip on disabled button, A disabled element does not fire events.',
                });
            }
        }
        else if (isDisabledButton) {
            setIsDisabledButton(false);
        }
    });
    return (React.createElement(MuiTooltip, __assign({ ref: tooltipRef, title: isDisabledButton ? '' : title, arrow: true, classes: classes, PopperProps: PopperProps }, additionProp, rest), ignorePointer ? (React.createElement(Mask, __assign({}, maskProps), children)) : (children)));
});
/** @release */
var RcTooltip = styled(_RcTooltip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), tooltipStyle);
RcTooltip.defaultProps = {
    placement: 'bottom',
    color: 'neutral.b04',
    textColor: 'neutral.f01',
    size: 'large',
};
RcTooltip.displayName = 'RcTooltip';
export { RcTooltip };
var templateObject_1;
